import React, { useCallback, useEffect, useMemo } from 'react'

import useTracker from 'src/lib/js/hooks/useTracker'
import { TrackingEvents } from 'src/shared/components/common/tracking/TrackingEvents'
import { CtaType } from 'src/apollo/sites'

import { getLinkEnumsFromSiteData } from 'shared/components/common/link/util'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import StickyFooter from 'public/components/default_template/footer/sticky_footer/StickyFooter'

export const getActionBannerContent = (
  actionBannerConfig: any | undefined,
  linkEnums: { displayName: string; value: string }[] | undefined
) => {
  const content = []

  if (actionBannerConfig?.ctaLink && actionBannerConfig?.ctaText) {
    content.push(actionBannerConfig.ctaLink, actionBannerConfig.ctaText)
  } else if (linkEnums && linkEnums[0]) {
    const firstLink = linkEnums[0]
    content.push(firstLink.value, firstLink.displayName)
  }

  return content
}

const ActionBannerStickyFooter = () => {
  const { restaurant } = useRestaurant()
  const { track } = useTracker()
  const actionBannerConfig = restaurant.content?.navConfig?.actionBannerConfig
  const links = getLinkEnumsFromSiteData(restaurant)

  const [ctaLink, ctaText] = useMemo(() => {
    return getActionBannerContent(actionBannerConfig, links)
  }, [actionBannerConfig, links])

  const showActionBanner = !!ctaLink && !!ctaText && actionBannerConfig?.enabled

  const trackClick = useCallback(() => {
    track(TrackingEvents.ACTION_BANNER_CLICKED, {
      ctaLink,
      ctaText
    })
  }, [ctaLink, ctaText, track])

  useEffect(() => {
    if (showActionBanner) {
      track(TrackingEvents.ACTION_BANNER_VIEWED, {
        ctaLink,
        ctaText
      })
    }
  }, [ctaLink, ctaText, showActionBanner, track])

  return (
    <>
      {showActionBanner ? (
        <StickyFooter
          primaryCta={{
            type: CtaType.Link,
            text: ctaText,
            link: ctaLink,
            onClick: trackClick
          }}
          customTheme={true}
        />
      ) : null}
    </>
  )
}

export default ActionBannerStickyFooter
